import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonFooter } from '@ionic/react';

import { ShowRoomPicsModal } from './Modal_ShowRoomPics';
import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

//import '../css/hotelCss.css';
import '../../../../css/qavaApp.css';


export function ViewNeedCleaningRoomsModal(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [roomPicsModal, setRoomPicsModal] = useState(false);
    let [roomPic1, setRoomPic1] = useState(null);
    let [roomPic2, setRoomPic2] = useState(null);
    let [roomPic3, setRoomPic3] = useState(null);
    let [roomPic4, setRoomPic4] = useState(null);

    let [roomID, setRoomID] = useState(null);
    let [showPasswordModal, setShowPasswordModal] = useState(false);
    //let [enteredPassword, setEnterPassword] = useState(null);

    //let [showInvoiceModal, setViewInvoiceModal] = useState(false);
    let [showNeedCleaningRoomDetailsModal, setNeedCleaningRoomDetailsModal] = useState(false);

    let [viewInventoryNeedCleaningRooms, setViewInventoryNeedCleaningRooms] = useState([]);




    useEffect(() => {
        if(props.openModal == true)
        {
            /*
            let formData = new FormData();
            formData.append('Tracker', props.tracker);
            formData.append('user', acctID);
            formData.append('xStartDateRange', props.startDate.toISOString().substr(0, 10));
            formData.append('xEndDateRange', props.endDate.toISOString().substr(0, 10));

        
            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: props.tracker,
                    user: acctID,
                    xStartDateRange: authenticatedMerchent_context.startDate,
                    xEndDateRange: authenticatedMerchent_context.endDate,
                    sessionID: sessionID,
    
                }),
            }
        
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
        
                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');
                    let confirmCleaned;
                    let approveCleaned;
        
                    if(cols[14] == 'yes')
                    {
                        confirmCleaned = 'none';
                        approveCleaned = 'inline-block';
                    }
                    else if(cols[14] == 'no')
                    {
                        confirmCleaned = 'inline-block';
                        approveCleaned = 'none'; 
                    }


                    setViewInventoryNeedCleaningRooms((prevOccupiedRooms) => {
                        return prevOccupiedRooms.concat({
                            roomID: cols[0],
                            roomType: cols[1],
                            roomDescription: cols[2],
                            roomPartNum: cols[3],
                            roomPhoneNumber: cols[4],
                            address: cols[5],
                            city: cols[6],
                            country: cols[7],
                            roomSalePrice: parseFloat(cols[8]).toFixed(2),
                            roomPic1: cols[9],
                            roomPic2: cols[10],
                            roomPic3: cols[11],
                            roomPic4: cols[12],
                            attachement: cols[13],
                            isCleanedStatus: cols[14],
                            confirmRoomCleanedButton: confirmCleaned,
                            approveRoomCleanedButton: approveCleaned,
                        })
                    });
                } 
            })
        }
    }, [props.openModal]);

    function confirmRoomCleaned(event)
    {
        /*
        let formData = new FormData();
        formData.append('Tracker', 74211);
        formData.append('user', acctID);
        formData.append('xInventoryRoomID', event[1]);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74211',
                user: acctID,
                xInventoryRoomID: event[1],
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);

        })
    
    }

    function approveRoomCleaned(enteredPassword)
    {
        /*
        let formData = new FormData();
        formData.append('Tracker', 74212);
        formData.append('user', acctID);
        formData.append('xInventoryRoomID', roomID);
        formData.append('xEnterAdminPassword', enteredPassword);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74212',
                user: acctID,
                xInventoryRoomID: roomID,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,

            }),
        }
        
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })
        
        setShowPasswordModal(false);

    }

    function approveCleanedHandler(e) {

        setRoomID(e[1])
        setShowPasswordModal(true);

    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        //alert('In onSubmitPasswordHandler');
        //alert(roomID);
        //alert(enteredPassword);
        //alert(event);
        //alert(event[0]);

        //setEnterPassword(event);
        approveRoomCleaned(enteredPassword);
    }

    function setRoomPicsModalHandler(event)
    {
        setRoomPic1(event[1]);
        setRoomPic2(event[2]);
        setRoomPic3(event[3]);
        setRoomPic4(event[4]);
        setRoomPicsModal(event[0]);
    }

    function closeModalHandler() {

        setViewInventoryNeedCleaningRooms([]);
        props.closeModal(false);
    }

    return (

        <React.Fragment>
            {props.openModal == true ?
            (
            <IonModal id='showNeedCleaningRooms'  isOpen={ props.openModal }>
                <IonText> Rooms Booked/Reserved </IonText>

                <IonGrid className='appGridContent'>
                    <IonRow >
                            <IonCol >Room ID</IonCol>
                            <IonCol >Room Type</IonCol>
                            {/*<IonCol >Phone Number</IonCol>*/}
                            {/*<IonCol >Sale Price</IonCol>*/}
                            <IonCol >Cleaned?</IonCol>                                        
                            <IonCol >Action</IonCol>
                    </IonRow>
                    {viewInventoryNeedCleaningRooms.map((detailData) =>   {
                        return (
                            <IonRow >
                                <IonCol >{detailData.roomID}</IonCol>
                                <IonCol >{detailData.roomType}</IonCol>
                                {/*<IonCol >{detailData.roomPhoneNumber}</IonCol>*/}
                                {/*<IonCol >{detailData.roomSalePrice}</IonCol>*/}
                                <IonCol >{detailData.isCleanedStatus}</IonCol>
                                <IonCol >
                                    {/*<IonButton className='gridResultColumnButton' onClick={() => setRoomPicsModalHandler([true, detailData.roomPic1, detailData.roomPic2, detailData.roomPic3, detailData.roomPic4])}> View </IonButton>*/}
                                    <IonButton style={{display: detailData.confirmRoomCleanedButton}} onClick={() => confirmRoomCleaned([true, detailData.roomID])}> Confirm Cleaned</IonButton>
                                    <IonButton style={{display: detailData.approveRoomCleanedButton}} onClick={() => approveCleanedHandler([true, detailData.roomID])}> Approve Cleaned </IonButton>
                                </IonCol>
                            </IonRow>
                        )
                    }
                    )}
                </IonGrid>

                <ShowRoomPicsModal openModal={ roomPicsModal } closeModal={() => setRoomPicsModal(false)} data={{
                                    roomPic1: roomPic1, 
                                    roomPic2: roomPic2, 
                                    roomPic3: roomPic3, 
                                    roomPic4: roomPic4, 
                                    }}></ShowRoomPicsModal>

                <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>
                                    
                <IonFooter className='modal_footer_button_center'>
                    <IonButton onClick={closeModalHandler}> Close </IonButton>
                </IonFooter>
            </IonModal>) : null }
        </React.Fragment>
    )
}